import { MittweidaFieldTypes } from './fields';

export const mittweidaSteps: Record<keyof MittweidaFieldTypes, string> = {
  financingNeedPage: 'financingNeedPage',
  userProfilePage: 'userProfilePage',
  fundingDetailsPage: 'fundingDetailsPage',
  companyDetailPage: 'companyDetailPage',
} as const;
